import API from '../../API/api';

function requestSaveVehicleConfiguratorSelection(filters, tyreOptions, vehicleList) {
    const postData = {
        filters,
        'tyreOptions': tyreOptions,
        'vehicleList': vehicleList,
    }
    return API.POST({
        apiPath: '/api/v2/setconfiguratorselection/',
        data: {
            postData
        },
        dataType: 'json'
    }).done(response => {
        return response;
    });
}

export { requestSaveVehicleConfiguratorSelection };
